var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4857 18H2.51429C1.12457 18 0 16.8646 0 15.4615V9.00001C0 7.59693 1.12457 6.46155 2.51429 6.46155H4.34286C4.71771 6.46155 5.02857 6.77539 5.02857 7.15386C5.02857 7.53232 4.71771 7.84616 4.34286 7.84616H2.51429C1.88343 7.84616 1.37143 8.36309 1.37143 9.00001V15.4615C1.37143 16.0985 1.88343 16.6154 2.51429 16.6154H13.4857C14.1166 16.6154 14.6286 16.0985 14.6286 15.4615V9.00001C14.6286 8.36309 14.1166 7.84616 13.4857 7.84616H11.6571C11.2823 7.84616 10.9714 7.53232 10.9714 7.15386C10.9714 6.77539 11.2823 6.46155 11.6571 6.46155H13.4857C14.8754 6.46155 16 7.59693 16 9.00001V15.4615C16 16.8646 14.8754 18 13.4857 18Z",
    fill: "#6d6a78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00017 11.5385C7.62531 11.5385 7.31445 11.2246 7.31445 10.8462V0.692308C7.31445 0.313846 7.62531 0 8.00017 0C8.37502 0 8.68588 0.313846 8.68588 0.692308V10.8462C8.68588 11.2246 8.37502 11.5385 8.00017 11.5385Z",
    fill: "#6d6a78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7427 4.15386C10.569 4.15386 10.3953 4.08924 10.2581 3.95078L7.51526 1.18155C7.25012 0.913858 7.25012 0.470781 7.51526 0.203089C7.78041 -0.0646037 8.21926 -0.0646037 8.48441 0.203089L11.2273 2.97232C11.4924 3.24001 11.4924 3.68309 11.2273 3.95078C11.0901 4.08924 10.9164 4.15386 10.7427 4.15386Z",
    fill: "#6d6a78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25716 4.1541C5.08344 4.1541 4.90973 4.08949 4.77259 3.95103C4.50744 3.68333 4.50744 3.24026 4.77259 2.97256L7.51544 0.203333C7.78059 -0.0643596 8.21944 -0.0643596 8.48459 0.203333C8.74973 0.471025 8.74973 0.914102 8.48459 1.18179L5.74173 3.95103C5.60459 4.08949 5.43087 4.1541 5.25716 4.1541Z",
    fill: "#6d6a78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.11d80b6168b9a1683966048f822b635c.svg";
export { ForwardRef as ReactComponent };